<script>
import { mapActions } from 'vuex'

export default {
  name: 'AllSmsesButton',
  props: ['tasks'],
  methods: {
    ...mapActions({
      sendAllNotifications: 'notificationsModule/sendAllNotifications'
    })
  }
}
</script>

<template>
  <button
    class="btn btn-success btn-sm"
    @click="sendAllNotifications"
  >
    Wyślij przygotowane SMSy
  </button>
</template>

<style scoped>

</style>
